import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function Flexyply() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            Flexiply, as the name suggests it is an extremely flexible plywood. These plies are widely accepted for
                            applications that need curves and bends. Flexiplies are made of layers of thin plies that bend into
                            various curved shapes quite easily.
                            <br /><br />
                            Additional qualities of Flexiplies include long lasting life, anti-fire properties, excellent weather
                            resistance, superior sound absorption, etc. Flexiply is a favourite amongst interior designers and
                            architectural consultants as it provides a classy combination of strength and elasticity. These plies
                            are ideal for creating a tasteful residence, novelties, exhibition designs and office interiors. TV
                            stands, chairs, columns, arches, hotel fittings, kitchen fittings and false ceilings are some common
                            applications.
                        </p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>OBSERVED VALUE</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontWeight: '500' }}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Moisture</td>
                                    <td className='text-start'>5% – 12%</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Glue Shear Strength <br />(after 72hrs. Boiling)</td>
                                    <td className='text-start'>1150 N<br />
                                        1250 N</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Adhesion to plywood</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Glue Shear Strength<br />
                                        (Dry State)</td>
                                    <td className='text-start'>1350 N 1500 N</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Static Bending Strength
                                        <br />Modulus of Rupture
                                        <br />– Along the grain
                                        <br />– Across the grain<br />
                                        Modulus of Elasticity<br />
                                        – Along the grain<br />
                                        – Across the grain
                                    </td>
                                    <td className='text-start'>65 N /sq.mm<br />
                                        40 N /sq.mm8305 N /sq.mm<br />
                                        4170 N /sq.mm</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Tensile Strength<br />
                                        – Along the grain<br />
                                        – Across the grain<br />
                                        – Sum of Tensile strength</td>
                                    <td className='text-start'>5500 N /sq.mm<br />
                                        3950 N /sq.mm<br />
                                        9400 N /sq.mm</td>
                                </tr>
                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
